import { useState } from "react";
import { Link } from "react-router-dom";
import LoginSvg from "../../assets/img/login-bg.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import request from "../../shared/utils/request";
import { FormError } from "../../shared/components/validationMessage";
import { LoadingButton } from "../../shared/components/loadingButton";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Login = () => {
  const [loader, setLoader] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: async (values) => {
      try {
        setLoader(true);
        const response = await request.post("studentlogin", values);
        if (response?.data?.status) {
          localStorage.setItem("token", response?.data?.token);
          localStorage.setItem("name", response?.data?.user?.name);
          localStorage.setItem("email", response?.data?.user?.email);
          localStorage.setItem(
            "courseType",
            response?.data?.user?.course?.type
          );
          if (response?.data?.user?.payment_status === "Pending") {
            window.location.href = "/student/payment";
          } else {
            window.location.href = "/student/dashboard";
          }
        } else {
          toast.error(response?.data?.message, {
            autoClose: 4000,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoader(false);
      }
    },
  });

  return (
    <section id="login-container">
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-md-6">
            <img src={LoginSvg} className="img-fluid" alt="" />
          </div>
          <div className="col-md-6">
            <div className="login-Card">
              <h1 className="text-center py-3">Login</h1>
              <form onSubmit={formik.handleSubmit}>
                <div className="form-group mb-4">
                  <label htmlFor="exampleInputEmail1">Email address</label>
                  <br />
                  <small id="emailHelp" className="form-text text-muted">
                    We'll never share your email with anyone else.
                  </small>
                  <input
                    type="email"
                    className="form-control eduform"
                    id="email"
                    placeholder="Email"
                    {...formik.getFieldProps("email")}
                  />
                  <FormError
                    touched={formik.touched.email}
                    error={formik.errors.email}
                  />
                </div>
                <div className="form-group mb-2">
                  <label htmlFor="exampleInputPassword1">Password</label>
                  <input
                    type="password"
                    className="form-control eduform"
                    id="password"
                    placeholder="Password"
                    {...formik.getFieldProps("password")}
                  />
                  <FormError
                    touched={formik.touched.password}
                    error={formik.errors.password}
                  />
                </div>
                <div className="row py-2">
                  <div className="col-md-6">
                    <div className="form-check mb-4" />
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <Link to={"forgot-password"}>
                      <p>Forgot Password?</p>
                    </Link>
                  </div>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <LoadingButton isLoading={loader} buttonText={"Login"} />
                </div>
              </form>
              <div className="d-flex justify-content-center py-4"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
